module.exports = __webpack_public_path__ + "static/media/trgcapital.f1495873.svg";